import { domain } from './webURL'

const getBackendHost = () => {
  if (typeof window === "undefined" || !window.location) {
    return `https://services.${domain}/`
  }

  const { protocol, hostname, port } = window.location

  if (!hostname) {
    return `https://services.${domain}/`
  }

  if (hostname === "127.0.0.1" || hostname === "localhost") {
    return "http://127.0.0.1:8088/services/"
  }

  let serviceHost = hostname.replace(/^www\./, "services.")
  if (serviceHost === domain) {
    serviceHost = `services.${domain}`
  }

  const portPart = port ? `:${port}` : ""
  return `${protocol}//${serviceHost}${portPart}/`
}

const backendHost = getBackendHost()

export const API_ROOT = backendHost



// WEBPACK FOOTER //
// ./src/api-config.js